/* eslint-disable arrow-body-style */
import { AxiosError, AxiosResponse } from 'axios';
import { ResponseStatusModel } from '../store/response-status/ResponseStatusModel';
import {
  ChangePasswordModel,
  LoginResponseDataModel,
  LoginUserModel,
  NewUserModel,
  UpdateUserModel,
  UserModel,
} from '../store/user/UserModel';
import SnackbarUtil from '../utils/SnackbarUtil';
import { axiosInstance } from '../utils/axiosConfig';

const USER_URL = '/api/user';
const AUTH_USER_URL = '/api/auth-user';
const CHANGE_PASSWORD_URL = '/api/change-password';

export const createUserAdapter = (newUser: NewUserModel): Promise<ResponseStatusModel> => {
  return axiosInstance
    .post(USER_URL, newUser)
    .then((response: AxiosResponse<ResponseStatusModel>): ResponseStatusModel => {
      response.data.status === 'ok'
        ? SnackbarUtil.success(response.data.message)
        : SnackbarUtil.error(response.data.message);
      return response.data;
    });
};

export const updateUserAdapter = (userId: string, userData: UpdateUserModel): Promise<ResponseStatusModel> => {
  return axiosInstance
    .put(`${USER_URL}/${userId}`, userData)
    .then((response: AxiosResponse<ResponseStatusModel>): ResponseStatusModel => {
      response.data.status === 'ok'
        ? SnackbarUtil.success(response.data.message)
        : SnackbarUtil.error(response.data.message);
      return response.data;
    });
};

export const changePasswordAdapter = (
  userId: string,
  currentPassword: string,
  newPassword: string,
): Promise<ChangePasswordModel> => {
  return axiosInstance
    .patch(CHANGE_PASSWORD_URL, { userId, currentPassword, newPassword })
    .then((response: AxiosResponse<ChangePasswordModel>): ChangePasswordModel => {
      response.data.status === 'ok'
        ? SnackbarUtil.success(response.data.message)
        : SnackbarUtil.error(response.data.message);
      return response.data;
    });
};

export const getUserAdapter = (userId: string): Promise<UserModel> => {
  return axiosInstance
    .get(`${USER_URL}/${userId}`)
    .then((response: AxiosResponse<UserModel>): UserModel => {
      return response.data;
    })
    .catch((error: AxiosError): UserModel => {
      SnackbarUtil.error(error.message);
      return {
        id: -1,
        firstName: '',
        lastName: '',
        email: '',
        owner: false,
        admin: false,
      };
    });
};

export const authenticateUserAdapter = (loginUser: LoginUserModel): Promise<LoginResponseDataModel | void> => {
  return axiosInstance
    .post(AUTH_USER_URL, loginUser)
    .then((response: AxiosResponse<LoginResponseDataModel>): LoginResponseDataModel => response.data)
    .catch((error: AxiosError): LoginResponseDataModel => {
      // @ts-ignore
      SnackbarUtil.error(error.response.data.message);
      return {
        token: '',
        user: {
          id: -1,
          firstName: '',
          lastName: '',
          email: '',
          owner: false,
          admin: false,
        },
      };
    });
};
